<ng-container *transloco="let t;">
    <ng-container *ngIf="pages; else schemasNotFound">
        <ng-container *media="'(min-width: 992px)'">
            <div class="table-responsive">
                <table class="table table-striped table-hover table-mobile-responsive">
                    <thead>
                        <tr>
                            <ng-container
                                *ngIf="currentTab === SchemaTabs.OTHERS && hasOthersSchemaAccess() as hasOthersSchemaAccess">
                                <th class="w-auto text-nowrap">
                                    <div class="header-flex sortable" (click)="sortBy('patientName')"
                                        (keyup.enter)="sortBy('patientName')" tabindex="0">
                                        <span class="header-text">
                                            {{ t('schema.tableheader.patientname') }}
                                        </span>
                                        <span *ngIf="sortColumn$.value == 'patientName'" class="header-arrow">
                                            {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                        </span>
                                    </div>
                                </th>
                            </ng-container>
                            <th class="w-auto text-nowrap">
                                <div class="header-flex sortable" (click)="sortBy('schemaTypeName')"
                                    (keyup.enter)="sortBy('schemaTypeName')" tabindex="0">
                                    <span class="header-text">
                                        {{ t('schema.tableheader.schema') }}
                                    </span>
                                    <span *ngIf="sortColumn$.value == 'schemaTypeName'" class="header-arrow">
                                        {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                    </span>
                                </div>
                            </th>
                            <th class="w-auto text-nowrap">
                                <div class="header-flex sortable" (click)="sortBy('createdDate')"
                                    (keyup.enter)="sortBy('createdDate')" tabindex="0">
                                    <span class="header-text">
                                        {{ t('schema.tableheader.createdat') }}
                                    </span>
                                    <span *ngIf="sortColumn$.value == 'createdDate'" class="header-arrow">
                                        {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                    </span>
                                </div>
                            </th>
                            <th class="w-auto text-nowrap">
                                <div class="header-flex sortable" (click)="sortBy('doctorOrganization')"
                                    (keyup.enter)="sortBy('doctorOrganization')" tabindex="0">
                                    <span class="header-text">
                                        {{ t('schema.tableheader.createdby') }}
                                    </span>
                                    <span *ngIf="sortColumn$.value == 'doctorOrganization'" class="header-arrow">
                                        {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                    </span>
                                </div>
                            </th>
                            <th class="w-auto text-nowrap">
                                <div class="header-flex sortable" (click)="sortBy('changedDate')"
                                    (keyup.enter)="sortBy('changedDate')" tabindex="0">
                                    <span class="header-text">
                                        {{ t('schema.tableheader.updatedat') }}
                                    </span>
                                    <span *ngIf="sortColumn$.value == 'changedDate'" class="header-arrow">
                                        {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                    </span>
                                </div>
                            </th>
                            <th class="w-auto text-nowrap">
                                <div class="header-flex sortable" (click)="sortBy('validFrom')"
                                    (keyup.enter)="sortBy('validFrom')" tabindex="0">
                                    <span class="header-text">
                                        {{ t('schema.tableheader.validperiod') }}
                                    </span>
                                    <span *ngIf="sortColumn$.value == 'validFrom'" class="header-arrow">
                                        {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                    </span>
                                </div>
                            </th>
                            <th class="w-auto text-nowrap">
                                <div class="header-flex sortable" (click)="sortBy('schemaStatus')"
                                    (keyup.enter)="sortBy('schemaStatus')" tabindex="0">
                                    <span class="header-text">
                                        {{ t('schema.tableheader.status') }}
                                    </span>
                                    <span *ngIf="sortColumn$.value == 'schemaStatus'" class="header-arrow">
                                        {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                    </span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-group-divider">
                        <tr *ngFor="let schema of paginatedSchemas$ | async"
                            [ngClass]="{'tr-schema-disabled tr-patient': schema.schemaStatus == SchemaStatus.EXPIRED }"
                            (click)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                            (keyup.enter)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                            tabindex="0">
                            <ng-container
                                *ngIf="currentTab === SchemaTabs.OTHERS && hasOthersSchemaAccess() as hasOthersSchemaAccess">
                                <td *ngIf="hasOthersSchemaAccess"
                                    [attr.data-content]=" t('schema.tableheader.patientname')">
                                    {{ schema.patientName }}<br>{{ schema.patientSurname }}
                                </td>
                            </ng-container>
                            <td [attr.data-content]="t('schema.tableheader.schema')">
                                {{ schema.schemaTypeName }}
                            </td>
                            <td [attr.data-content]="t('schema.tableheader.createdat')">
                                {{ schema.createdDate | dateFormatted }}
                            </td>
                            <td [attr.data-content]="t('schema.tableheader.createdby')">
                                {{ schema.doctorOrganization }}
                            </td>
                            <td [attr.data-content]="t('schema.tableheader.updatedat')">
                                {{ schema.changedDate | datetimeFormatted }}
                            </td>
                            <td [attr.data-content]="t('schema.tableheader.validperiod')">
                                {{ schema.validFrom |
                                dateFormatted }} - {{ schema.validTo |
                                dateFormatted }}
                            </td>
                            <td [attr.data-content]="t('schema.tableheader.status')">
                                {{ schema.schemaStatus | schemaStatus | async }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *ngIf="pages > 1" class="row">
                <div class="col-auto align-content-center" style="min-width: 20%;">
                    <button type="button" class="btn btn-sm wp-btn-outline float-start"
                        [attr.aria-label]="t('schemapagination.previous')" (click)="changePage(currentPage - 1)"
                        [ngClass]="{'d-none' : currentPage === 1}">
                        <svg class="icon-sm icon-primary" aria-hidden="true">
                            <use xlink:href="assets/icons.svg#icon-chevron-left"></use>
                        </svg>
                        <span>{{ t('schemapagination.previous') }}</span>
                    </button>
                </div>
                <div class="col">
                    <nav aria-label="Schema table pagination">
                        <ul class="pagination pagination-sm justify-content-center m-0">
                            <li *ngIf="!visiblePaginationPages.includes(1) " class="page-item">
                                <a class="page-link" [attr.aria-label]="t('schemapagination.firstpage')"
                                    (click)="changePage(1)" (keyup.enter)="changePage(1)" tabindex="0">
                                    <span aria-hidden="true">1</span>
                                </a>
                            </li>
                            <li *ngIf="!visiblePaginationPages.includes(1)" class="page-item" style="cursor: default;">
                                <div class="page-link">...</div>
                            </li>
                            <li class="page-item" *ngFor="let page of visiblePaginationPages"
                                [class.active]="page === currentPage">
                                <a class="page-link" (click)="changePage(page)" (keyup.enter)="changePage(page)"
                                    [attr.aria-label]="t('accessibility.gotopage') + ' ' + page" tabindex="0">{{ page
                                    }}</a>
                            </li>
                            <li *ngIf="!visiblePaginationPages.includes(lastPage)" class="page-item">
                                <div class="page-link">...</div>
                            </li>
                            <li *ngIf="!visiblePaginationPages.includes(lastPage)" class="page-item">
                                <a class="page-link" [attr.aria-label]="t('schemapagination.lastpage')"
                                    (click)="changePage(lastPage)" (keyup.enter)="changePage(lastPage)"
                                    [attr.aria-label]="t('schemapagination.lastpage')" tabindex="0">
                                    <span aria-hidden="true">{{ lastPage }}</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="col-auto align-content-center" style="min-width: 20%;">
                    <button type="button" class="btn btn-sm wp-btn-outline float-end"
                        [attr.aria-label]="t('schemapagination.next')" (click)="changePage(currentPage + 1)"
                        [ngClass]="{'d-none' : currentPage === lastPage}">
                        <span>{{ t('schemapagination.next') }}</span>
                        <svg class="icon-sm icon-primary" aria-hidden="true" focusable="false">
                            <use xlink:href="assets/icons.svg#icon-chevron-right"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </ng-container>

        <ng-container *media="'(max-width: 991px)'">
            <div class="row g-3 mb-3 schema-card-list">
                <div class="col-12" *ngFor="let schema of paginatedSchemas$ | async"
                    [ngClass]="{'tr-schema-disabled tr-patient': schema.schemaStatus == SchemaStatus.EXPIRED }">
                    <div class="card" (click)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                        (keyup.enter)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                        tabindex="0">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col me-auto">
                                    <h5 class="card-title">{{ schema.schemaTypeName }}</h5>
                                </div>
                                <div class="col-auto">
                                    <span class="d-flex gap-1 align-items-center">
                                        <div class="fw-medium" style="font-size: small;">
                                            {{ schema.schemaStatus | schemaStatus | async }}
                                        </div>
                                        <svg class="icon icon-md icon-primary" aria-hidden="true" focusable="false">
                                            <use xlink:href="assets/icons.svg#icon-file-text"></use>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <ng-container
                                *ngIf="currentTab === SchemaTabs.OTHERS && hasOthersSchemaAccess() as hasOthersSchemaAccess">
                                <div class="row mb-2">
                                    <div class="col">
                                        {{ t('schema.tableheader.patientname') }}:
                                        <span class="text-decoration-underline">
                                            {{ schema.patientName }} {{ schema.patientSurname }}
                                        </span>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="row g-3">
                                <div class="col me-auto">
                                    <div class="fw-normal" style="font-size: small;">{{
                                        t('schema.tableheader.createdby') }}</div>
                                    <div class="fw-light" style="font-size: small;">{{ schema.doctorOrganization }}
                                    </div>
                                </div>
                                <div class="col-auto text-end">
                                    <div class="fw-normal" style="font-size: small;">{{
                                        t('schema.tableheader.createdat') }}</div>
                                    <div class="fw-light" style="font-size: small;">{{ schema.createdDate |
                                        dateFormatted }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block">
                <div class="row align-items-center">
                    <div class="col-4 text-start">
                        <button type="button" class="btn btn-sm wp-btn-outline"
                            [attr.aria-label]="t('schemapagination.previous')" (click)="changePage(currentPage - 1)"
                            [ngClass]="{'d-none': currentPage === 1, 'disabled': currentPage === 1}">
                            <svg class="icon-sm" aria-hidden="true" focusable="false">
                                <use xlink:href="assets/icons.svg#icon-chevron-left"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="col-4 text-center">
                        <span>{{ currentPage }}</span> af <span>{{lastPage}}</span>
                    </div>
                    <div class="col-4 text-end">
                        <button type="button" class="btn btn-sm wp-btn-outline"
                            [attr.aria-label]="t('schemapagination.next')" (click)="changePage(currentPage + 1)"
                            [ngClass]="{'d-none': currentPage === lastPage, 'disabled': currentPage === lastPage}">
                            <svg class="icon-sm" aria-hidden="true" focusable="false">
                                <use xlink:href="assets/icons.svg#icon-chevron-right"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #schemasNotFound>
        <div class="text-center">
            <p class="fs-5" [innerHTML]="t('schema.schemasnotfound')"></p>
        </div>
    </ng-template>

</ng-container>